import { Injectable } from "@angular/core";
import { IUseCase } from "@karma-games/angular-devkit/src/lib/interfaces";
import { RoundRepository } from "../round.repository";

@Injectable()
export class CancelBetUseCase implements IUseCase<number, Promise<void>> {
    constructor(private roundRepository: RoundRepository) {
    }

    async execute(betIndex: number): Promise<void> {
        try {
            await this.roundRepository.cancelBet(betIndex);
        } catch (e) {
            throw e;
        }
    }
}
